import React, { useState } from 'react';

const TweetMedia = ({ media }) => {
  const [portraitVideos, setPortraitVideos] = useState({});

  const handleVideoMetadata = (index, event) => {
    const video = event.target;
    const isPortrait = video.videoHeight > video.videoWidth;
    setPortraitVideos(prev => ({ ...prev, [index]: isPortrait }));
  };

  if (!media || media.length === 0) return null;

  return (
    <div className="tweet-media-grid">
      {media.map((item, i) => {
        if (item.type === 'photo') {
          // Use media_url_https or media_url, not the shortened url
          const imageUrl = item.media_url_https || item.media_url || item.url;
          const fullQualityUrl = imageUrl?.replace('?format=jpg&name=small', '?format=jpg&name=orig')
                                         .replace('&name=small', '&name=orig') || imageUrl;
          
          return (
            <img
              key={i}
              src={fullQualityUrl}
              alt="tweet media"
              className="tweet-media-image"
              loading="lazy"
              onError={(e) => {
                console.error('Failed to load image:', fullQualityUrl);
                e.target.style.display = 'none';
              }}
            />
          );
        }

        // Video or animated_gif
        let videoUrl = null;
        let posterUrl = item.media_url_https || item.preview_image_url;
        
        // Try video_info.variants first (standard Twitter format)
        if (item.video_info?.variants && item.video_info.variants.length > 0) {
          const videoVariant = item.video_info.variants
            .filter(v => v.bitrate && v.content_type === 'video/mp4')
            .sort((a, b) => (b.bitrate || 0) - (a.bitrate || 0))[0];
          videoUrl = videoVariant?.url;
        } 
        // Fallback to variants array
        else if (item.variants && item.variants.length > 0) {
          const videoVariant = item.variants
            .filter(v => v.bitrate)
            .sort((a, b) => (b.bitrate || 0) - (a.bitrate || 0))[0];
          videoUrl = videoVariant?.url;
        }
        
        // Final fallback to url field if no variants found
        if (!videoUrl) {
          videoUrl = item.media_url_https || item.url;
        }

        const videoClass = portraitVideos[i] 
          ? 'tweet-media-video-portrait' 
          : 'tweet-media-video';

        return (
          <video
            key={i}
            controls={item.type !== 'animated_gif'}
            poster={posterUrl}
            preload="metadata"
            className={videoClass}
            loop={item.type === 'animated_gif'}
            muted={item.type === 'animated_gif'}
            autoPlay={item.type === 'animated_gif'}
            playsInline
            onLoadedMetadata={(e) => handleVideoMetadata(i, e)}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      })}
    </div>
  );
};

export default TweetMedia;
